import { useMarcarAlertaLeida } from "@/shared/hooks/useNotificaciones.hook";
import { RiCalendarCheckLine, RiCalendarCloseLine, RiCalendarEventLine, RiChat1Line, RiFileCopy2Line, RiGovernmentLine } from "@remixicon/react";
import { format, parseISO } from "date-fns";
import type { FunctionComponent } from "react";
import { Link, useNavigate } from "react-router";

interface ItemNotificacionProps {
    IdCaso: number
    IdTramite: number
    idAlertaUsuarios: number
    idUsuario: number
    TipoAlerta: string
    Alerta: string
    FechaAlerta: string
    TipoActividad: TipoActividad
    IsReaded: boolean
    handleNotificaciones: () => void
}

enum TipoActividad{
    DocumentoAgregado = 1,
    FijacionCreada = 2,
    AudienciaCelebrada = 3,
    SalaAsignada = 4,
    SalaRevocada = 5,
    MensajeTribunal = 6,
    AudienciaCancelada = 7,
}

const ICON_BY_NOFICATION_TYPE : Record<TipoActividad, React.ReactNode> = {
    [TipoActividad.DocumentoAgregado]: <RiFileCopy2Line color="#0050DA" size={40} />,
    [TipoActividad.FijacionCreada]: <RiCalendarEventLine color="#0050DA" size={40} />,
    [TipoActividad.AudienciaCelebrada]: <RiCalendarCheckLine color="#0050DA" size={40} />,
    [TipoActividad.SalaAsignada]: <RiGovernmentLine color="#0050DA" size={40} />,
    [TipoActividad.SalaRevocada]: <RiGovernmentLine color="#EC3340" size={40} />,
    [TipoActividad.MensajeTribunal]: <RiChat1Line color="#0050DA" size={32} />,
    [TipoActividad.AudienciaCancelada]: <RiCalendarCloseLine color="#ef4444" size={32} />,
}

const ItemNotificacion: FunctionComponent<ItemNotificacionProps> = ({
    TipoAlerta, Alerta, FechaAlerta, TipoActividad, IdCaso, IdTramite, idAlertaUsuarios, idUsuario, IsReaded, handleNotificaciones
}) => {

    const navigate = useNavigate()

    const {
        mutate: marcarAlertaLeida, isPending: isPendingMarcarAlertaLeida
    } = useMarcarAlertaLeida();
    
    const handleClickItem = () => {
        navigate(`/caso/${IdCaso}/tramites/${IdTramite}`);
        handleNotificaciones();
        if(!IsReaded){
            marcarAlertaLeida(
                {
                    idAlertaUsuarios,
                    idUsuario
                },
                {
                    onError: (err) => {
                        console.log(err)
                    },
                    onSuccess: (res) => {
                        console.log(res)
                    },
                }
            )
        }
    }

    return (
        <>
        <div 
            className="flex text-[#5E5D62] px-4 py-6 hover:bg-gray-100 hover:text-[#0050DA] cursor-pointer"
            onClick={handleClickItem}
        >
            <div className="flex gap-4">
                <span>{ICON_BY_NOFICATION_TYPE[TipoActividad]}</span>
                <div>
                    <h5 className="h5 font-Bold">
                        {TipoAlerta}
                    </h5>
                    <p>
                        {Alerta}
                    </p>
                </div>
            </div>
        </div>
        </>
    );
}

export default ItemNotificacion;